var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRestore = function SvgRestore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "4 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.885 8.667 1.69 1.69-.942.943-3.3-3.3 3.3-3.3.943.943-1.691 1.69h4.781a5.333 5.333 0 1 1 0 10.667h-6v-1.333h6a4 4 0 1 0 0-8H7.885Z",
    fill: "var(--color-primary-800)"
  })));
};
export default SvgRestore;